<template>
	<page>
		<module enable-flex>
			
			<m-operate>
				<c-button power="b_finance_sys_account_add" color="sys" @click="addAccount()">添加账户</c-button>
			</m-operate>
			
			<c-table ref="table" code="finance_sys_account_list">				
				<c-table-column
					label="状态"
					name="state"
				>
					<template v-slot="{data}">
                        <span v-if="data.id > 0">{{accountStateName[data.state]}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="账户名称"
					name="account_name"
				>
				</c-table-column>
				
				<c-table-column
					label="账户余额"
					name="account_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.account_balance">￥{{data.account_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="冻结金额"
					name="frozen_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.frozen_balance">￥{{data.frozen_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="可提现余额"
					name="can_withdraw_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.can_withdraw_balance">￥{{data.can_withdraw_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="保证金额度"
					name="deposit_money"
				>
					<template v-slot="{data}">
                        <span v-if="data.deposit_money">￥{{data.deposit_money}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="保证金余额"
					name="deposit_balance"
				>
					<template v-slot="{data}">
                        <span v-if="data.deposit_balance">￥{{data.deposit_balance}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>


				<c-table-column
					label="待结算金额"
					name="settle_amount"
				>
					<template v-slot="{data}">
                        <span v-if="data.settle_amount">￥{{data.settle_amount}}</span>
                        <span v-else>--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="210"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.id > 0" @click="edit(data)">编辑</c-table-button>
						<c-table-button power="b_finance_sys_account_del" v-if="data.id > 0 && data.account_balance == 0 && data.deposit_balance == 0 && data.settle_amount == 0" @click="stateHandle(2,data)">注销</c-table-button>
						<c-table-button v-if="data.id > 0 && data.state == 1 && (data.account_balance != 0 || data.deposit_balance != 0 || data.settle_amount != 0)" @click="stateHandle(3,data)">挂起</c-table-button>
						<c-table-button v-if="data.id > 0 && data.state == 3" @click="stateHandle(1,data)">恢复</c-table-button>
						<c-table-button @click="showRecord(data)">查看收支流水</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<c-dialog ref="editAccount" :title="editState ? '编辑账户' : '新增账户'" width="600" @resolve="submit">
			<c-form ref="form">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="账户名称" name="account_name" required></c-form-item>
				<c-form-item v-show="!editState" type="input" label="初始化账户余额" name="account_balance" required></c-form-item>
				<c-form-item type="input" label="保证金额度" name="deposit_money" required></c-form-item>
				<c-form-item v-show="!editState" type="input" label="初始化保证金余额" name="deposit_balance" required></c-form-item>
			</c-form>
		</c-dialog>

        <c-dialog ref="rewardDialog" title="收益明细" width="1000" :button="false">
            <m-search ref="rewardSearch" @search="rewardSearchHandle">
                <c-form ref="form" inline>
                    <c-form-item type="checkbox" label="收益类型" name="reward_type" :options="rewardType">
                    </c-form-item>
                    <c-form-item type="checkbox" label="收益状态" name="state" :options="rewardState">
                    </c-form-item>
                    <c-form-item type="datetime" label="创建时间" start-name="start_date" end-name="end_date">
                    </c-form-item>
                </c-form>
            </m-search>
            <c-table ref="rewardTable" height="400">
                <c-table-column label="单号" width="150" name="record_number">
                </c-table-column>
                <c-table-column label="收益类型" width="100" name="reward_type">
                    <template v-slot="{data}">
                        <span v-if="data.reward_type==1">分销差价</span>
                        <span v-if="data.reward_type==2">直推收益</span>
                        <span v-if="data.reward_type==3">间推收益</span>
                        <span v-if="data.reward_type==4">区代奖励</span>
                        <span v-if="data.reward_type==22">平级奖励</span>
                    </template>
                </c-table-column>
                <c-table-column label="收益金额" name="record_money" width="120">
                    <template v-slot="{data}">
                        <span v-if="data.state==0">￥{{(data.estimated_record_money||0).toFixed(2)}}</span>
                        <span v-if="data.state==1"><span style="color:darkgray">[预估]</span>￥{{(data.estimated_record_money||0).toFixed(2)}}</span>
                        <span v-if="data.state==2">￥{{(data.record_money||0).toFixed(2)}}</span>
                    </template>
                </c-table-column>
                <c-table-column label="收益状态" name="state" width="75">
                    <template v-slot="{data}">
                      <span v-if="data.state==0">
                        <span style="color:#aaaaaa">
                          {{rewardStateMap[data.state]}}
                        </span>
                      </span>
                        <span v-if="data.state==1">
                        <span style="color:sandybrown">
                          {{rewardStateMap[data.state]}}
                        </span>
                      </span>
                      <span v-if="data.state==2">
                        <span style="color:darkgreen">
                          {{rewardStateMap[data.state]}}
                        </span>
                      </span>
                    </template>
                </c-table-column>
                <c-table-column label="关联会员" name="nick_name" width="250">
                    <template v-slot="{data}">
                        {{data.nick_name}}【{{data.user_manage_mobilephone}}】
                    </template>
                </c-table-column>
                <c-table-column label="推荐等级" name="level_name" width="80">
                    <template v-slot="{data}">
						<span v-if="data.reward_type != 1">
							{{data.level_name}}
						</span>
                        <span v-else>
							--
						</span>
                    </template>
                </c-table-column>
                <c-table-column label="关联单号" name="relate_number" width="150">
                </c-table-column>
                <c-table-column label="商品原价" name="original_product_money" width="95">
                    <template v-slot="{data}">
						<span v-if="data.reward_type == 1 || data.reward_type == 5">
                            ￥{{(data.original_product_money||0).toFixed(2)}}
						</span>
                        <span v-else>
							--
						</span>
                    </template>
                </c-table-column>
                <c-table-column label="商品成交价" name="product_money" width="95">
                    <template v-slot="{data}">
						<span v-if="data.reward_type == 1">
							￥{{(data.product_money||0).toFixed(2)}}
						</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>
                <c-table-column label="收益时间" name="create_date" width="155">
                </c-table-column>
                <c-table-column label="到账时间" name="settlement_date" width="155">
                    <template v-slot="{data}">
                        {{data.settlement_date||'--'}}
                    </template>
                </c-table-column>
                <c-table-column label="备注" name="remark" width="350">
                    <template v-slot="{data}">
                        {{data.remark||'--'}}
                    </template>
                </c-table-column>
            </c-table>
        </c-dialog>
	</page>
</template>

<script>
	export default {
		name: 'finance_sys_account_list',
		
		data() {
			return {
				accountStateName: {
					1: '正常',
					2: '注销',
					3: '挂起'
				},
				editState: false,
                rewardState: [{
                    name: '已取消',
                    value: 0
                }, {
                    name: '待到账',
                    value: 1
                }, {
                    name: '已到账',
                    value: 2
                }],
                rewardStateMap: {
                    '0': '已取消',
                    '1': '待到账',
                    '2': '已到账'
                },
                rewardType: [{
                    name: '分销差价',
                    value: 1
                }, {
                    name: '区代奖励',
                    value: 4
                }, {
                    name: '平级奖励',
                    value: 22
                }],
                stateType: [{
                    name: '启用',
                    value: 1
                }, {
                    name: '禁用',
                    value: 2
                }],
                member_user_id:-1
			}
		},
		
		mounted() {
			this.$refs.table.load({
				url: '/sys/account/list'
			});
		},
		
		methods: {
            rewardSearchHandle(data) {
                data.member_user_id = this.member_user_id;
                this.$refs.rewardTable.load({
                    url: '/member_user/reward/list',
                    data
                });
            },

			addAccount() {
				this.editState = false;
				this.$refs.form.set({
					id: '',
					account_name: '',
					account_balance: 0,
					deposit_money: 0,
					deposit_balance: 0
				});
				this.$refs.editAccount.open();
			},

			edit(val) {
				this.editState = true;
				this.$refs.form.set(val);
				this.$refs.editAccount.open();
			},

			submit(stop) {
				stop();
				this.$refs.form.submit({
					url: this.editState ? '/sys/account/edit' : '/sys/account/add',
					rule: {
						account_name: [{
							type: 'empty',
							word: '请填写账户名称',
							skip: () => {
								return this.editState;
							}
						}],
						deposit_money: [{
							type: 'empty',
							word: '请填写保证金额度',
							skip: () => {
								return this.editState;
							}
						}],
						account_balance: '请填写初始化账户余额',
						deposit_balance: '请填写初始化保证金余额'
					},
					success: (data, res) => {
						this.$message({
							text: '保存成功'
						});
						this.$refs.table.update();
						this.$refs.editAccount.close();
					}
				});
			},
			
			stateHandle(state, val){
				var text,operation;
				if(state == 2) {
					operation = "注销";
					text = '注销后将删除账户，确定注销[' + val.account_name + ']账户吗？';
				}else if(state == 3) {
					operation = "挂起";
					text = '挂起后账户将不可用，确定挂起[' + val.account_name + ']账户吗？';
				}else{
					operation = "恢复";
					text = '确定恢复[' + val.account_name + ']账户吗？';
				}
				this.$confirm({
					text: text,  // 提示内容,
					buttonName: '确定',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url: '/sys/account/state',
							data: {
								id: val.id,
								state: state
							},
							loading: false,  // 是否显示loading，
							success: data => {
								this.$message({
				                  	text: operation + '成功',
				                  	icon: 'success'
				                });
								this.$refs.table.update();
							},  // 成功回调，接收参数为返回值的obj属性
						});
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},

			showRecord(val){
                if (val.id > 0){
                    this.navigateTo({
                        path: '/sys_account_record/'+val.id,
                        query: {
                            id: val.id,
                            account_name: val.account_name
                        }
                    });
                }else {
                    this.member_user_id = val.id;
                    this.$refs.rewardDialog.open();
                    this.$refs.rewardTable.load({
                        url: '/member_user/reward/list',
                        data: {
                            member_user_id: this.member_user_id
                        }
                    });
                }
			}
		}
	}
</script>

<style lang="stylus" scoped>
	
</style>